import { render, staticRenderFns } from "./plugin-list.vue?vue&type=template&id=090dcb98&scoped=true&"
import script from "./plugin-list.vue?vue&type=script&lang=js&"
export * from "./plugin-list.vue?vue&type=script&lang=js&"
import style0 from "./plugin-list.vue?vue&type=style&index=0&id=090dcb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dcb98",
  null
  
)

export default component.exports